import { render, staticRenderFns } from "./ChatwootStats.vue?vue&type=template&id=122605fa&"
import script from "./ChatwootStats.vue?vue&type=script&lang=js&"
export * from "./ChatwootStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports